import React, { PureComponent } from 'react'
import { FormattedHTMLMessage } from 'react-intl'

import { scrollTo } from './services/utils'

import Activity from './Activity'
import Loader from './Loader'
import Error from './Error'

import { SkiIcon } from './Icons'

import './Activities.css'

export default class Activites extends PureComponent {
  componentDidUpdate(prevProps) {
    const { activities } = this.props
    if (activities !== prevProps.activities) {
      scrollTo(this.element)
    }
  }
  renderActivities() {
    const { activities, activity, technicalError, onChanged } = this.props

    if (activities === undefined && !technicalError) {
      return <Loader loading={true} />
    }

    if (activities !== undefined && activities.length > 0) {
      return activities.map(a => (
        <Activity
          name={a.name}
          normalizedCode={a.normalizedCode}
          code={a.code}
          key={a.id}
          comment={a.comment}
          onChanged={onChanged}
          selected={activity === a.code}
        />
      ))
    }

    if (
      technicalError ||
      (activities !== undefined && activities.length === 0)
    ) {
      return <Error technicalError={technicalError} kind="activities" />
    }
  }

  render() {
    return (
      <div ref={el => (this.element = el)} className="cm-activities">
        <div className="cm-activities--title">
          <SkiIcon className="cm-activities--picto" />
          <FormattedHTMLMessage id="the_activities" />
        </div>
        <div className="cm-activities--outer">{this.renderActivities()}</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Activities.js